// _BeforeLoad.ts
// document.body doesn't exist yet in <head> - only the <html> attribute is handled here.
// -----------------------------------------------------------------------
// MAINTENANCE RULES - keep this file dependency-free:
// 1. NEVER add imports here (not even from _Themes.ts or _Utils.ts).
//    Any import may cause webpack splitChunks to extract a shared chunk,
//    making this entry wait for other chunks to load - the code would
//    then run AFTER the first paint and the FOUC returns.
// 2. NEVER add exports and NEVER import this file from other modules.
//    Without import/export, TS treats it as a script (not a module),
//    so `declare const` correctly binds to globals from the Razor layout.
//    Importing it elsewhere would re-execute the init in another bundle.
// 3. Keep it tiny and self-contained. Small duplication (e.g. hardcoded
//    theme names) is intentional and preferred over sharing code.
// 4. This entry must be excluded from runtimeChunk / splitChunks in
//    webpack config and included in <head> WITHOUT defer/async.
// 5. document.body doesn't exist yet in <head> - only the <html>
//    attribute is handled here. AG Grid mode and date inputs are synced
//    on window load via _Themes.ts (syncThemeAfterLoad).
// -----------------------------------------------------------------------
declare const lightThemeName: string;
declare const darkThemeName: string;
(() => {
    // theme handle
    const theme: string = localStorage.theme
        || (window.matchMedia("(prefers-color-scheme: dark)").matches ? darkThemeName : lightThemeName);        
    document.documentElement.setAttribute("data-theme", theme);
    document.documentElement.dataset.agThemeMode = theme;
    localStorage.theme = theme;
})();